var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtaskControlAdded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8047 4.19526C14.0651 4.45561 14.0651 4.87772 13.8047 5.13807L6.70711 12.2357C6.31658 12.6262 5.68342 12.6262 5.29289 12.2357L2.19526 9.13807C1.93491 8.87772 1.93491 8.45561 2.19526 8.19526C2.45561 7.93491 2.87772 7.93491 3.13807 8.19526L6 11.0572L12.8619 4.19526C13.1223 3.93491 13.5444 3.93491 13.8047 4.19526Z",
    fill: "#699F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtaskControlAdded);
export default __webpack_public_path__ + "static/media/subtask-control-added.17aa5ca4ed59c7233a754c2d3ed6673c.svg";
export { ForwardRef as ReactComponent };